export default __webpack_public_path__ + "static/media/fireicon.362f102f.svg";